export class BatchCommandResult {
    public results: any[];
    public transactionIndex: number;
}
